import React from 'react';
import { useNavigate, Link } from 'react-router-dom';
import Logo from '@/components/Logo';
import { Clock, ShieldCheck, Phone, Mail, LogOut } from 'lucide-react';
import { useAuth } from '@/context/AuthContext';
import { CHURCH } from '@/api/client';

export default function PendingApproval() {
  const navigate = useNavigate();
  const { user, logout } = useAuth();

  if (user && user.status === 'approved') {
    navigate('/member/dashboard');
    return null;
  }

  const status = user?.status || 'pending';
  const isRejected = status === 'rejected';
  const isInactive = status === 'inactive';

  return (
    <div className="min-h-screen bg-moj-cream flex items-center justify-center px-4 py-16">
      <div className="card-moj p-8 sm:p-10 max-w-lg w-full text-center">
        <div className="flex justify-center mb-4"><Logo size="lg" showText={false}/></div>
        {isRejected ? (
          <>
            <h1 className="font-serif text-2xl text-red-700 mb-2">Account not approved</h1>
            <p className="text-moj-charcoal mb-6">Your membership request was not approved. Please contact the pastoral team.</p>
          </>
        ) : isInactive ? (
          <>
            <h1 className="font-serif text-2xl text-moj-purple-deep mb-2">Your account is currently inactive</h1>
            <p className="text-moj-charcoal mb-6">Please reach out to a pastor or admin if you’d like to reactivate your account.</p>
          </>
        ) : (
          <>
            <div className="w-16 h-16 mx-auto rounded-full gradient-purple flex items-center justify-center mb-4">
              <Clock size={28} className="text-moj-gold"/>
            </div>
            <h1 className="font-serif text-2xl text-moj-purple-deep mb-2">Welcome to the family</h1>
            <p className="text-moj-charcoal mb-2">Your profile has been created and is pending approval by a pastor or admin.</p>
            <p className="text-moj-charcoal/70 mb-6 text-sm">We’ll send a notification as soon as you’re approved — usually within a day. May God bless you while you wait!</p>
            {user?.google_email && (
              <div className="text-sm bg-moj-cream rounded-lg p-3 inline-block">
                Signed in as <strong>{user.full_name || user.google_email}</strong>
              </div>
            )}
          </>
        )}

        <div className="mt-6 pt-6 border-t border-moj-gold/30 text-sm text-moj-charcoal/80">
          <p className="mb-2 font-semibold text-moj-purple-deep">Need to reach us?</p>
          <p className="flex items-center justify-center gap-2"><Phone size={14}/> {CHURCH.phone}</p>
          <p className="flex items-center justify-center gap-2"><Mail size={14}/> {CHURCH.email}</p>
        </div>

        <div className="flex flex-wrap justify-center gap-3 mt-6">
          <Link to="/" className="btn-outline">Back to home</Link>
          {user && <button onClick={async () => { await logout(); navigate('/'); }} className="btn-primary"><LogOut size={16}/> Sign out</button>}
        </div>
      </div>
    </div>
  );
}
